import React from 'react';

const GrownthSeriesIcon = ({ width = 23, height = 24, color = 'white', ...props }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84857 17.53V22.1515H6.47001V17.53H1.84857ZM0 17.3452C0 16.4263 0.744871 15.6815 1.66372 15.6815H6.65487C7.57371 15.6815 8.31859 16.4263 8.31859 17.3452V22.3363C8.31859 23.2552 7.57371 24.0001 6.65487 24.0001H1.66372C0.744871 24.0001 0 23.2552 0 22.3363V17.3452Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3584 5.28317C12.3584 4.83395 12.7226 4.4698 13.1718 4.4698H17.3258C17.775 4.4698 18.1391 4.83395 18.1391 5.28317V9.44246C18.1391 9.89167 17.775 10.2558 17.3258 10.2558C16.8766 10.2558 16.5124 9.89167 16.5124 9.44246V6.09654H13.1718C12.7226 6.09654 12.3584 5.73238 12.3584 5.28317Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9054 4.70821C18.223 5.02595 18.2228 5.54094 17.9051 5.85849L9.53677 14.2216C9.21903 14.5391 8.70403 14.539 8.38649 14.2212C8.06895 13.9035 8.06911 13.3885 8.38685 13.0709L16.7551 4.70785C17.0729 4.3903 17.5879 4.39046 17.9054 4.70821Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.18899 2.21829V13.6018C3.18899 14.2143 2.69241 14.7109 2.07985 14.7109C1.46728 14.7109 0.970703 14.2143 0.970703 13.6018V1.84857C0.970703 0.827635 1.79834 0 2.81928 0H20.8676C21.8885 0 22.7162 0.827635 22.7162 1.84857V19.9015C22.7162 20.9224 21.8885 21.7501 20.8676 21.7501H10.4191C9.80652 21.7501 9.30994 21.2535 9.30994 20.6409C9.30994 20.0284 9.80652 19.5318 10.4191 19.5318H20.4979V2.21829H3.18899Z"
      fill={color}
    />
  </svg>
);

export default GrownthSeriesIcon;
